import type { CommandBody } from '../CrossOriginMessage';

/**
 * Indicates that the entity of class Class or Package was changed.
 */
export class ClassListChangedCommandBody implements CommandBody {
  package?: {
    id: string;
    name: string;
  };
  class?: {
    id: string;
    name: string;
    packageId: string;
  };
}
